import DisasterDamage_Minimal from './DisasterDamage_Minimal'
import DisasterDamage_Documents from './DisasterDamage_Documents'

const DisasterDamageFragments = { DisasterDamage_Minimal, DisasterDamage_Documents }

export default DisasterDamageFragments
